import { combineReducers } from 'redux';
import * as actions from '../../actions/types';
import { createSelector } from 'reselect';

const cinemaId = (state = null, action) => {
  switch (action.type) {
    case actions.CHANGE_PREFERRED_CINEMA:
        return action.cinemaId;
    default:
        return state;
  }
}

const areaId = (state = null, action) => {
  switch (action.type) {
    case actions.CHANGE_PREFERRED_CINEMA:
        return action.areaId;
    case actions.UI_AREA_SELECTOR_SELECT_AREA:
        return 'global' === action.context ? action.areaId : state;
    default:
      return state;
  }
}

const area = (state: { type: string, id: number } | null = null, action) => {
  switch (action.type) {
    case actions.UI_AREA_SELECTOR_SELECT_AREA:
        return 'global' === action.context ? { type: action.areaType, id: action.areaId } : state;
    default:
        return state;
  }
}

export const getUserPreferences = state => state.user.preferences;
export const getSelectedArea: (state: any) => { type: 'state' | 'area', id: number } | null = createSelector([getUserPreferences], preferences => preferences.area);

export default combineReducers({
    cinemaId,
    areaId,
    area,
});